<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// ....video play
/*
const playBtn = document.getElementById('videoPlayBtnUnique');
const modal = document.getElementById('videoModalUnique'); const closeBtn = document.getElementById('videoCloseBtnUnique');
const iframe = document.getElementById('videoIframeUnique');
// Video URL (YouTube Example)
const videoUrl = "https://cdn.shopify.com/videos/c/o/v/4795e87136dd465cb6024431bf736fb1.mp4"; playBtn.addEventListener('click', () => {
    modal.classList.add('active'); iframe.src = videoUrl;
});
closeBtn.addEventListener('click', () => {
    modal.classList.remove('active'); iframe.src = "";
});
// Close modal on outside click
modal.addEventListener('click', (e) => {
    if (e.target === modal) {
        modal.classList.remove('active'); iframe.src = "";
    }
}); */

// Accordion Script - Only one open at a time
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".accordion-header-unique").forEach((header) => {
        header.addEventListener("click", () => {
            const item = header.parentElement;

            // Close all other accordions
            document.querySelectorAll(".accordion-item-unique").forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.classList.remove("active");
                    // Optional: Change icon back to +
                    const icon = otherItem.querySelector(".accordion-icon-unique");
                    if (icon) icon.textContent = "+";
                }
            });

            // Toggle the clicked accordion
            item.classList.toggle("active");

            // Change icon for clicked accordion
            const icon = header.querySelector(".accordion-icon-unique");
            if (icon) {
                icon.textContent = item.classList.contains("active") ? "−" : "+";
            }
        });
    });

    //  Accordion Script-2
        const accordionHeaders = document.querySelectorAll('.accordion-header-uniq');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const accordionItem = header.parentElement;

            // Close other accordions
            document.querySelectorAll('.accordion-item-uniq').forEach(item => {
                if (item !== accordionItem) {
                    item.classList.remove('accordion-item-active-uniq');
                }
            });

            // Toggle current accordion
            accordionItem.classList.toggle('accordion-item-active-uniq');
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const desc = document.querySelector('.productView-desc.halo-text-format');
  if (!desc) return;

  const fullText = desc.innerHTML.trim();
  const textOnly = desc.innerText.trim();
  const words = textOnly.split(/\s+/);

  if (words.length <= 10) return;

  const shortText = words.slice(0, 10).join(" ");

  desc.innerHTML = `
    <span class="short-text">${shortText}...</span>
    <span class="full-text" style="display:none;">${fullText}</span>
    <span class="read-more-link">Read More</span>
  `;

  const readMore = desc.querySelector('.read-more-link');
  const shortSpan = desc.querySelector('.short-text');
  const fullSpan = desc.querySelector('.full-text');

  readMore.addEventListener('click', function () {
    const isOpen = fullSpan.style.display === "inline";

    if (isOpen) {
      fullSpan.style.display = "none";
      shortSpan.style.display = "inline";
      readMore.innerText = "Read More";
    } else {
      fullSpan.style.display = "inline";
      shortSpan.style.display = "none";
      readMore.innerText = "Read Less";
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const buyNowBtn = document.querySelector("#buy-now-section");

  if (!buyNowBtn) return;

  buyNowBtn.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href");
    const targetEl = document.querySelector(targetId);

    if (!targetEl) return;

    e.preventDefault();

    const headerOffset = 80; // sticky header safe
    const elementPosition = targetEl.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  });
});

